import api from './api';

export const getStats = async () => {
  try {
    const response = await api.get('/stats');
    return response;
  } catch (error) {
    console.error('Error fetching stats:', error);
    throw error;
  }
};

export const updateStats = async (statsData) => {
  try {
    console.log('Sending stats data:', statsData);
    const response = await api.post('/stats', statsData);
    return response;
  } catch (error) {
    console.error('Error updating stats:', error);
    throw error;
  }
};

export const getStatsHistory = async () => {
  try {
    const response = await api.get('/stats/history');
    return response;
  } catch (error) {
    console.error('Error fetching stats history:', error);
    throw error;
  }
};